import React, { Component } from 'react';
import "./Popup.scss";

export default class PopupMain extends Component {
    constructor() {
        super();
        this.togglePopup = this.togglePopup.bind(this);
        this.state = {
            isPopupActive: false,
            ClassName: "",
            Component: null,
            refresh: true
        }
    }
    componentDidMount() {
        window.addEventListener("showpopup", (event) => {
            this.setState({
                isPopupActive: true,
                ClassName: event.detail.ClassName,
                Component: event.detail.Component,
                refresh: event.detail.refresh
            })
        })
    }
    togglePopup() {
        this.setState({
            isPopupActive: !this.state.isPopupActive
        }, () => {
            if (this.state.isPopupActive == false) {
                if (this.state.refresh) {
                    window.location.reload();
                } else {
                    window.dispatchEvent(new CustomEvent("changeState", {
                        "detail": "changeState"
                    }));
                    this.setState({
                        isPopupActive: false
                    })
                }
            }
        })
    }
    render() {
        return (
            <div className={`popup-helper ${this.state.ClassName}`} style={{ display: this.state.isPopupActive ? "block" : "" }} onClick={this.togglePopup}>
                <div className="fade"></div>
                <div className="padding">
                    <div className="close" onClick={this.togglePopup}><i className="fas fa-times"></i></div>
                    <div className="container">
                        <div className="wrapper">
                            {this.state.Component}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Popup/PopupMain.jsx